<template>
  <nav class="nav-bar">
    <router-link to="/module1" class="nav-item" active-class="active">
      <i class="fas fa-cubes"></i>自然科学·斗拱力学
    </router-link>
    <router-link to="/module2" class="nav-item" active-class="active">
      <i class="fas fa-timeline"></i>科学家精神·营造学社
    </router-link>
    <router-link to="/module3" class="nav-item" active-class="active">
      <i class="fas fa-scroll"></i>古籍著作·营造法式
    </router-link>
    <router-link to="/module4" class="nav-item" active-class="active">
      <i class="fas fa-map-marked-alt"></i>文化传承·匠作流布
    </router-link>
  </nav>
</template>

<script setup>
// 无需逻辑
</script>

<style scoped>
.nav-bar {
  display: flex;
  background: #2f241b;
  padding: 0 20px;
  gap: 5px;
  border-bottom: 1px solid #5f4a33;
  flex-shrink: 0;
}
.nav-item {
  padding: 14px 28px;
  font-size: 1.1rem;
  font-weight: 500;
  color: #cdb99b;
  cursor: pointer;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  transition: all 0.2s;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  letter-spacing: 1px;
  text-decoration: none;
}
.nav-item i {
  margin-right: 8px;
  color: #b58b5b;
}
.nav-item:hover {
  background: #3f3226;
  color: #f5e5c9;
}
.nav-item.active {
  background: #3f2e1d;
  color: #ffd98c;
  border-bottom: 3px solid #c49a6c;
}
</style>